import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import App from "./App";
import store from "./store/store";
import "./index.scss";
import "./i18n";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import FilePreviewStandaloneRoot, {
  isFilePreviewStandalonePath,
} from "./features/file-preview/standalone/FilePreviewStandaloneRoot";
import MobileAppPromptGate from "./features/mobile-view/components/MobileAppPrompt/MobileAppPromptGate";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { showUpdateNotification } from "./serviceWorkerUpdate";
import { registerChunkReload } from "./utils/chunkReload";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const isStandaloneFilePreviewPath = isFilePreviewStandalonePath(
  window.location.pathname
);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <ErrorBoundary>
        {isStandaloneFilePreviewPath ? (
          <FilePreviewStandaloneRoot />
        ) : (
          <MobileAppPromptGate>
            <App />
          </MobileAppPromptGate>
        )}
      </ErrorBoundary>
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

// Lưới an toàn: nếu tải chunk lazy thất bại (bản cũ gặp bundle mới), reload 1 lần.
registerChunkReload();

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Hiển thị thông báo có đếm ngược rồi tự động cập nhật lên phiên bản mới.
    showUpdateNotification(registration);
  },
});
